import React, { useContext, useMemo } from 'react';
import { ProductTransaction, ProductTransactionType } from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../../types/product_master_data/productMasterData';
import { Container } from '../../../../../../../../types/container';
import { CustomFieldContext } from '../../../../../../../../context/CustomFieldContext';
import { CustomFieldEntityType } from '../../../../../../../../types/custom_field';
import CustomFieldInput from '../../../../../../Common/CustomFieldInput';
import { UserContext } from '../../../../../../../../context/UserContext';
import { ContactContext } from '../../../../../../../../context/ContactContext';
import { ProductMasterDataContext } from '../../../../../../../../context/ProductMasterDataContext';

interface ProductTransactionDestinationCustomFieldsProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  productMasterData?: ProductMasterData;
  container?: Container;

  disabled?: boolean;
}

export default function ProductTransactionDestinationCustomFields({
  transaction,
  setTransaction,
  productMasterData: pmd,
  disabled = false,
}: ProductTransactionDestinationCustomFieldsProps) {
  const { customFields } = useContext(CustomFieldContext);
  const { companyUsers } = useContext(UserContext);
  const { contacts } = useContext(ContactContext);
  const { productMasterData } = useContext(ProductMasterDataContext);

  const items = useMemo(() => {
    return [...customFields.values()].filter(cf => {
      if (cf.hidden) return false;
      if (cf.entityType === CustomFieldEntityType.product) return true;
      return false;
    });
  }, [customFields]);

  if (transaction.type === ProductTransactionType.outbound) return null;

  return (
    <Grid item xs={12}>
      <Grid container rowSpacing={1} columnSpacing={1} alignItems={'center'}>
        {items
          .sort((a, b) => a.index - b.index)
          .map(field => {
            if (field.generated && !transaction.product.toCustomFields.get(field.id)?.value) return null;

            return (
              <Grid item xs={6}>
                <CustomFieldInput
                  key={field.id}
                  item={field}
                  value={transaction.product.toCustomFields.get(field.id)?.value}
                  entity={transaction}
                  withCustomField={(id, value) => transaction.withToCustomField(value, id)}
                  onChange={value => setTransaction(new ProductTransaction(transaction))}
                  disabled={disabled || field.generated}
                  pmdId={transaction.product.pmdId}
                  users={companyUsers}
                  contacts={contacts}
                  productMasterData={productMasterData}
                />
              </Grid>
            );
          })}
      </Grid>
    </Grid>
  );
}
